module.exports = __webpack_public_path__ + "static/media/mu.ad383cac.webp";